export default __webpack_public_path__ + "static/media/landing1.b0c94d9b.png";